import { render } from "./scrollTop.vue?vue&type=template&id=ae95c442"
import script from "./scrollTop.vue?vue&type=script&lang=js"
export * from "./scrollTop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__